document.addEventListener("DOMContentLoaded", function () {
	// --- DOM & Config ---
	const form = document.querySelector(".js-custom-made-funnel-form");
	if (!form) return;
	const errorMsgs = FoxTheme.contactStrings;
	const funnelContainer = document.querySelector(".funnel-container");
	const shadowFormId = funnelContainer?.getAttribute("data-shadow-form-id");

	// Create and show an error message for a field
	function createErrorSpan(target, msg, className = "js-error-msg") {
		let errorSpan = target.parentNode.querySelector("." + className);
		if (errorSpan) errorSpan.remove();
		if (!msg) return null;
		const err = document.createElement("span");
		err.className = "form-message form-message--error " + className;
		err.style.color = "#E8083E";
		err.style.display = "block";
		err.style.marginTop = "0.2em";
		err.textContent = msg;
		target.parentNode.appendChild(err);
		return err;
	}

	// Remove error message from a field
	function removeError(field) {
		field.removeAttribute("aria-invalid");
		if (field.tagName === "SELECT") {
			const selectWrapper = field.closest(".form-field");
			if (selectWrapper) {
				const err = selectWrapper.querySelector(".js-error-msg");
				if (err) err.remove();
			}
		} else {
			const err = field.parentNode.querySelector(".js-error-msg");
			if (err) err.remove();
		}
	}

	// Show error for a field, handling selects specially
	function showError(field, msg) {
		removeError(field);
		if (!msg) return;
		if (field.tagName === "SELECT") {
			// For selects, show error outside the select wrapper
			const selectWrapper = field.closest(".form-field");
			if (selectWrapper) {
				let span = selectWrapper.querySelector(".js-error-msg");
				if (!span) {
					span = document.createElement("span");
					span.className = "form-message form-message--error js-error-msg";
					span.style.color = "#E8083E";
					span.style.display = "block";
					span.style.marginTop = "0.2em";
					selectWrapper.appendChild(span);
				}
				span.innerText = msg;
				span.style.display = "block";
			}
			field.setAttribute("aria-invalid", "true");
		} else {
			let span = field.parentNode.querySelector(".js-error-msg");
			if (!span) {
				span = createErrorSpan(field, msg, "js-error-msg");
			}
			span.innerText = msg;
			span.style.display = "block";
			field.setAttribute("aria-invalid", "true");
		}
	}

	// Email validation: at least one char + @ + at least one char + . + at least one char
	function isValidEmail(email) {
		return /^[^@]+@[^@]+\.[^@]+$/.test(email);
	}

	// List of required field names
	const requiredFields = ["first_name", "last_name", "email", "confirm_email", "phone", "preferred_channel", "residence_country"];

	// Validate a single field for required-ness, with optional showError
	function validateField(field, showErrorFlag = false) {
		if (!field) return true;
		let valid = true;
		let msg = errorMsgs?.default;
		if (requiredFields.includes(field.name) && !field.value.trim()) {
			if (field.name === "first_name") msg = errorMsgs?.firstName;
			if (field.name === "last_name") msg = errorMsgs?.lastName;
			if (field.name === "email") msg = errorMsgs?.email;
			if (field.name === "confirm_email") msg = errorMsgs?.confirmEmail;
			if (field.name === "phone") msg = errorMsgs?.phone;
			if (field.name === "preferred_channel") msg = errorMsgs?.preferredChannel;
			if (field.name === "residence_country") msg = errorMsgs?.country;
			valid = false;
		}
		// Email format validation
		if (field.name === "email" && field.value.trim() && !isValidEmail(field.value.trim())) {
			msg = errorMsgs?.emailFormat || "Format d'email invalide";
			valid = false;
		}
		if (showErrorFlag && !valid) {
			showError(field, msg);
		} else if (valid) {
			removeError(field);
		}
		return valid;
	}

	// Validate that email and confirm_email match and are filled, with optional showError
	function validateEmailsMatch(showErrorFlag = false) {
		const email = form.querySelector('[name="email"]');
		const confirm = form.querySelector('[name="confirm_email"]');
		let valid = true;
		if (!email.value.trim()) {
			if (showErrorFlag) showError(email, errorMsgs?.email);
			valid = false;
		}
		if (!confirm.value.trim()) {
			if (showErrorFlag) showError(confirm, errorMsgs?.confirmEmail);
			valid = false;
		}
		if (email.value && confirm.value && email.value !== confirm.value) {
			if (showErrorFlag) {
				showError(email, errorMsgs?.emailMatch);
				showError(confirm, errorMsgs?.emailMatch);
			}
			valid = false;
		}
		// Email format validation
		if (email.value && !isValidEmail(email.value)) {
			if (showErrorFlag) showError(email, errorMsgs?.emailFormat || "Format d'email invalide");
			valid = false;
		}
		if (email.value && confirm.value && email.value === confirm.value && isValidEmail(email.value)) {
			removeError(email);
			removeError(confirm);
		}
		return valid;
	}

	// Remove errors on input/blur if field becomes valid, but do not show errors
	requiredFields.forEach((name) => {
		const field = form.querySelector(`[name="${name}"]`);
		if (field) {
			field.addEventListener("blur", () => {
				validateField(field, false);
				if (name === "email" || name === "confirm_email") validateEmailsMatch(false);
			});
			field.addEventListener("input", () => {
				validateField(field, false);
				if (name === "email" || name === "confirm_email") validateEmailsMatch(false);
			});
		}
	});

	// --- Shadow Form Handling ---

	// Hide the shadow form (used for backend submission)
	function hideShadowFormFunnel() {
		document.querySelectorAll(`div[data-forms-id="forms-root-${shadowFormId}"]`).forEach((div) => {
			if (div.closest(".section-app")) {
				div.closest(".section-app").style.display = "none";
			} else {
				div.style.display = "none";
			}
		});
	}
	hideShadowFormFunnel();

	// Inject user data and recap into the shadow form for backend submission
	function injectToShadowForm() {
		const SEPARATOR = "|||";
		// Gather contact info fields with label extraction
		const contactArr = [];
		let emailValue = "";
		let civiliteAdded = false;

		// Get the data-lang attribute from the form wrapper
		const langValue = document.querySelector(".funnel-form-wrapper")?.getAttribute("data-lang") || "";
		// Add language as a field in the content array
		if (langValue) {
			contactArr.push("lang: " + langValue);
		}
		form.querySelectorAll("input, textarea, select").forEach((node) => {
			if (!node.name || node.type === "file" || node.offsetParent === null) return;
			// Only include relevant fields
			if (
				!["civilite", "first_name", "last_name", "email", "confirm_email", "phone", "preferred_channel", "residence_country", "commentaire"].includes(
					node.name
				)
			)
				return;
			let label = "";
			// const labelEl = form.querySelector('label[for="' + node.id + '"]');
			// if (labelEl) label = labelEl.innerText.trim();
			// else label = node.name.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
			label = node.name;
			let value = "";
			if (node.type === "radio") {
				// Only add checked radio, and only once for civilite
				if (node.name === "civilite") {
					if (civiliteAdded) return;
					let checked = form.querySelector(`[name="civilite"]:checked`);
					if (checked) {
						value = checked.value;
						civiliteAdded = true;
					} else {
						return;
					}
				} else {
					let checked = form.querySelector(`[name="${node.name}"]:checked`);
					value = checked ? checked.value : "";
				}
			} else if (node.tagName === "SELECT") {
				value = node.options[node.selectedIndex]?.text || "";
			} else {
				value = node.value;
			}
			if (node.name === "email") emailValue = value;
			if (value) contactArr.push(label + ": " + value);
		});
		const contactStr = contactArr.join(SEPARATOR);

		// Gather recap info from summary fields
		const recapFields = [
			{ id: "summary-material", label: "matiere" },
			{ id: "summary-shape", label: "forme" },
			{ id: "summary-color", label: "couleur" },
			{ id: "summary-ribbon", label: "gros_grain" },
			{ id: "summary-ribbon-color", label: "couleur_gros_grain" },
			{ id: "summary-bow", label: "noeud" },
			{ id: "summary-veil", label: "voilette" },
			{ id: "summary-size", label: "taille" },
			{ id: "summary-price", label: "total" },
		];
		const recapArr = [];
		recapFields.forEach((f) => {
			let el = document.getElementById(f.id);
			let value = el ? el.textContent.trim() : "";
			recapArr.push(`${f.label}: ${value}`);
		});
		const recapStr = recapArr.join(SEPARATOR);

		// Inject into shadow form
		const host = document.querySelector("#app-embed");
		const root = host?.shadowRoot;
		if (root) {
			// Inject email as in restoration
			const shadowEmail = root.querySelector("#email");
			if (shadowEmail && emailValue) {
				shadowEmail.value = emailValue;
				shadowEmail.dispatchEvent(new Event("input", { bubbles: true }));
			}
			const shadowContent = root.querySelector("#custom\\#content");
			const shadowDemand = root.querySelector("#custom\\#demande");
			if (shadowContent) {
				shadowContent.value = contactStr;
				shadowContent.dispatchEvent(new Event("input", { bubbles: true }));
			}
			if (shadowDemand) {
				shadowDemand.value = recapStr;
				shadowDemand.dispatchEvent(new Event("input", { bubbles: true }));
			}
		} else {
			console.warn(`[FUNNEL] Shadow form with id ${shadowFormId} not found`);
		}
	}

	// Fill the confirmation recap block with user info and selections
	function fillConfirmationRecap() {
		// Fill user info
		const getVal = (name) => form.querySelector(`[name="${name}"]`)?.value || "";
		const getSelectText = (name) => {
			const sel = form.querySelector(`[name="${name}"]`);
			return sel ? sel.options[sel.selectedIndex]?.text || "" : "";
		};
		const setText = (id, val) => {
			const el = document.getElementById(id);
			if (el) el.textContent = val || "-";
		};
		setText("recap-prenom", getVal("first_name"));
		setText("recap-nom", getVal("last_name"));
		setText("recap-email", getVal("email"));
		setText("recap-telephone", getVal("phone"));
		setText("recap-residence-country", getSelectText("residence_country"));
		setText("recap-canal-prefere", getSelectText("preferred_channel"));
		setText("recap-commentaire", getVal("commentaire"));

		// Fill recap
		const fields = [
			{ form: "summary-material", confirm: "summary-material-confirm" },
			{ form: "summary-shape", confirm: "summary-shape-confirm" },
			{ form: "summary-color", confirm: "summary-color-confirm" },
			{ form: "summary-ribbon", confirm: "summary-ribbon-confirm" },
			{ form: "summary-ribbon-color", confirm: "summary-ribbon-color-confirm" },
			{
				form: "summary-ribbon-secondary-color",
				confirm: "summary-ribbon-color-secondary-confirm",
			},
			{ form: "summary-bow", confirm: "summary-bow-confirm" },
			{ form: "summary-veil", confirm: "summary-veil-confirm" },
			{ form: "summary-size", confirm: "summary-size-confirm" },
			{ form: "summary-price", confirm: "summary-price-confirm" },
		];
		fields.forEach((f) => {
			const src = document.getElementById(f.form);
			const dest = document.getElementById(f.confirm);
			if (src && dest) dest.textContent = src.textContent;
		});
		// Total
		const totalSrc = document.getElementById("summary-total");
		const totalDest = document.getElementById("summary-total-confirm");
		if (totalSrc && totalDest) totalDest.textContent = totalSrc.textContent;
	}

	// --- Submission Handler ---

	// Attach to submit button
	const submitBtn = form.querySelector(".js-funnel-submit");
	if (submitBtn) {
		submitBtn.addEventListener("click", function (e) {
			e.preventDefault();
			// Validate all required fields and show errors if invalid
			let valid = true;
			requiredFields.forEach((name) => {
				const field = form.querySelector(`[name="${name}"]`);
				if (field && !validateField(field, true)) valid = false;
			});
			if (!validateEmailsMatch(true)) valid = false;
			if (!valid) return;

			Shopify.analytics.publish("custom_demi_mesure_confirm", {
				event: "select_content",
				event_category: "custom made funnel",
				event_action: "confirmation",
			});

			// Inject to shadow form (do not submit)
			injectToShadowForm();

			// Fill confirmation recap
			fillConfirmationRecap();
			submitBtn.disabled = true;
			submitBtn.classList.add("isloading");
			// Submit the shadow form
			const host = document.querySelector("#app-embed");
			const root = host?.shadowRoot;
			if (root) {
				const shadowForm = root.querySelector("form");
				if (shadowForm) {
					shadowForm.requestSubmit ? shadowForm.requestSubmit() : shadowForm.submit();
				}
			}

			// Wait 5 seconds before showing the confirmation
			setTimeout(() => {
				// Show the custom confirmation block
				const confirmationBlock = document.querySelector(".custom-funnel-confirmation");
				if (confirmationBlock) {
					form.style.display = "none";
					confirmationBlock.style.display = "block";
					confirmationBlock.scrollIntoView({ behavior: "smooth" });

					// Hide aside recap
					const asideRecap = document.querySelector(".js-funnel-recap-aside");
					if (asideRecap) asideRecap.style.display = "none";
				}

				// Restore the submit button
				submitBtn.disabled = false;
				submitBtn.classList.remove("isloading");
			}, 5000);
		});
	}
});
